import { render, staticRenderFns } from "./XCreateButton.vue?vue&type=template&id=4da34e9c"
import script from "./XCreateButton.vue?vue&type=script&lang=js"
export * from "./XCreateButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports